import { type ReactNode } from 'react';
import { IconCurrencyDollar, IconCurrencyRubel } from '@tabler/icons-react';
import { Group } from '@mantine/core';
import { Currency } from '../model';

const currenciesMap = (size: number): Partial<Record<Currency, ReactNode>> => {
    return {
        [Currency.CURRENCY_UNSPECIFIED]: '-',
        [Currency.CURRENCY_RUB]: <IconCurrencyRubel size={size} />,
        [Currency.CURRENCY_USD]: <IconCurrencyDollar size={size} />,
    };
};

export const getCurrencyIcon = (currency?: Currency, size: number = 18): ReactNode => {
    if (!currency) {
        return null;
    }

    return <Group component='span'>{currenciesMap(size)[currency]}</Group>;
};
